import React, { useContext } from 'react';
import { Route, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = ({serverPages}) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);

  return (
    <>
      <Routes>
        <Route path={routes.pshome.path}  element={<routes.pshome.component />} />
        <Route path={routes.home.path}  element={<routes.home.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />   
      </Routes>
    </>
  );
};

App.propTypes = {};

App.defaultProps = {};
